<app-navigation></app-navigation>
<mat-card class="card">
  <mat-card-content>
    <form [formGroup]="form" class="form">
      <h1>Passwort zurücksetzen</h1>
      <mat-form-field class="input-section">
        <mat-label>Email</mat-label>
        <input type="email" matInput formControlName="email" placeholder="Ex. pat@example.com" autocomplete="email" />
        @if (form.controls.email.hasError('email') && !form.controls.email.hasError('required')) {
          <mat-error>Bitte prüfen Sie, ob die Email-Adresse Tippfehler enthält.</mat-error>
        }
        @if (form.controls.email.hasError('required')) {
          <mat-error>Email-Adresse ist ein <strong>Pflichtfeld</strong></mat-error>
        }
      </mat-form-field>

      @if ($authError() !== '') {
        <mat-error>{{ $authError() }}</mat-error>
        <br />
      }

      @if ($result() !== '') {
        <br />
        <p class="success-text">
          {{ $result() }}
        </p>
        <br />
      }
    </form>

    <div class="buttons">
      <button mat-flat-button color="secondary" (click)="onCancel()">Abbrechen</button>
      @if (showRegister) {
        <button routerLink="../register" mat-button>zur Registrierung</button>
      }

      <button mat-flat-button color="primary" (click)="onReset()">Link zusenden</button>
    </div>
  </mat-card-content>
</mat-card>
